exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":root {\n  --primary: #013188;\n  --primary-darker: #002d72;\n  --secondary: #ff720a;\n  --secondary-darker: #dd5f13;\n  --button-text: #fefefe;\n  --disabled: #c2c2c2;\n  --button-text-disabled: rgba(0,0,0,0.38);\n  --bg-auth: url(" + require("assets/imgs/login/bg.jpg") + ");\n  --logo-auth: none;\n  --logo-header: none;\n  --favicon: none;\n}\n[data-component='security-check-registration-registration'] .btn-continue {\n  top: 150px;\n}\n[data-component='security-check-registration-registration'] p {\n  color: #474947;\n  font-size: 12px;\n}\nwidth 600px.question {\n  font-weight: bold;\n  margin: 40px 0 20px;\n}\n.question-step {\n  position: absolute;\n  left: 0;\n  top: 50px;\n  width: 100%;\n  height: 100%;\n  padding: 30px 0;\n}\n.question-step .form-control {\n  width: 70%;\n}\n.mat-option-text {\n  text-transform: initial !important;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/autentication/security-check-registration/registration/registration.component.styl
// module id = ../../../../../src/app/autentication/security-check-registration/registration/registration.component.styl
// module chunks = main